module.exports = __webpack_public_path__ + "img/vending_preview.fe89ca2d.png";